function pickWatcher(store) {
  if (store.getters['hub/isEnabled']) {
    return {
      isReadyNow: () => store.state.hub.isHubConfigLoaded === true,
      watch: (cb) =>
        store.watch(
          (state) => state.hub.isHubConfigLoaded,
          (val) => {
            if (val === true) cb();
          }
        )
    };
  }
  if (store.getters['auth0/enabled']) {
    return {
      isReadyNow: () => !!(store.state['cs-session'] && store.state['cs-session'].token),
      watch: (cb) =>
        store.watch(
          (state) => state['cs-session'] && state['cs-session'].token,
          (val) => {
            if (val) cb();
          }
        )
    };
  }
  return {
    isReadyNow: () =>
      store.getters['session/isReady'] === true && store.getters['session/isTokenNotExpired'](),
    watch: (cb) =>
      store.watch(
        (state, getters) => getters['session/isReady'] && getters['session/isTokenNotExpired'](),
        (val) => {
          if (val) cb();
        }
      )
  };
}

export default function waitForAuthReady(store, timeoutMs) {
  const { isReadyNow, watch } = pickWatcher(store);

  if (isReadyNow()) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    let resolved = false;
    let unwatch = null;

    const timer = setTimeout(() => {
      if (resolved) return;
      resolved = true;
      if (typeof unwatch === 'function') unwatch();
      resolve(false);
    }, timeoutMs);

    unwatch = watch(() => {
      if (resolved) return;
      resolved = true;
      clearTimeout(timer);
      if (typeof unwatch === 'function') unwatch();
      resolve(true);
    });
  });
}
